// TUT-529 — a ficha de finalização: o rascunho (preenchido da ficha técnica do
// processo e do KPI da perícia) e a gravação (o gesto de quem elabora, ou a
// correção do revisor).
// TUT-535 — a ficha técnica do processo, que é a fonte do rascunho, editada na
// tela do processo, e o resultado do laudo do perito, por perícia.
import { demoApi } from "../demo-data";
import type {
  FichaTecnicaDoProcesso,
  FichaTecnicaLida,
  GravarFichaInput,
  GravarFichaResponse,
  GravarFichaTecnicaInput,
  ItemDaFicha,
  PericiaDaFichaTecnica,
  RascunhoDaFichaResponse,
  RegistrarResultadoDoLaudoInput,
} from "../types";
import { request } from "./infra";

// Lido aqui, e não importado: o empacotador só dobra a constante no módulo
// que a escreve, e é isso que tira o demo do build de produção (TUT-448).
const useDemoApi = import.meta.env.VITE_API_MODE === "demo";

export const apiDasFinalizacoes = {
  rascunhoDaFicha(itemKind: ItemDaFicha, itemId: string): Promise<RascunhoDaFichaResponse> {
    if (useDemoApi) {
      return itemKind === "LEGAL_BRIEF" ? demoApi.rascunhoDaFichaDaPeca(itemId) : demoApi.rascunhoDaFichaDoLaudo(itemId);
    }
    const busca = new URLSearchParams({ itemKind, itemId });
    return request<RascunhoDaFichaResponse>(`/finalizacoes/rascunho?${busca.toString()}`);
  },
  gravarFicha(input: GravarFichaInput): Promise<GravarFichaResponse> {
    if (useDemoApi) {
      return input.itemKind === "LEGAL_BRIEF" ? demoApi.gravarFichaDaPeca(input) : demoApi.gravarFichaDoLaudo(input);
    }
    return request<GravarFichaResponse>("/finalizacoes", { method: "POST", body: JSON.stringify(input) });
  },
  fichaTecnicaDoProcesso(processId: string): Promise<FichaTecnicaLida> {
    if (useDemoApi) return demoApi.fichaTecnicaDoProcesso(processId);
    return request<FichaTecnicaLida>(`/processes/${encodeURIComponent(processId)}/ficha-tecnica`);
  },
  gravarFichaTecnica(processId: string, input: GravarFichaTecnicaInput): Promise<{ ficha: FichaTecnicaDoProcesso }> {
    if (useDemoApi) return demoApi.gravarFichaTecnica(processId, input);
    return request<{ ficha: FichaTecnicaDoProcesso }>(`/processes/${encodeURIComponent(processId)}/ficha-tecnica`, {
      method: "PUT",
      body: JSON.stringify(input),
    });
  },
  registrarResultadoDoLaudo(
    processId: string,
    expertiseId: string,
    input: RegistrarResultadoDoLaudoInput,
  ): Promise<PericiaDaFichaTecnica> {
    if (useDemoApi) return demoApi.registrarResultadoDoLaudo(processId, expertiseId, input);
    return request<PericiaDaFichaTecnica>(
      `/processes/${encodeURIComponent(processId)}/ficha-tecnica/pericias/${encodeURIComponent(expertiseId)}`,
      { method: "PUT", body: JSON.stringify(input) },
    );
  },
};
